import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { api } from "../../config/Api";
import { CreateProductRequest, PageResp, ProductReq, ProductRes } from "../../types/productType";
import { error } from "console";


// response,request
export const fetchSellerProduct = createAsyncThunk<PageResp<ProductRes>, void>("/sellerProduct/fetchSellerProduct", async (_, { rejectWithValue }) => {
    try {
        const response = await api.get(`/api/sellers/products`,{params:
            { page: 0, size: 10, sortBy: "createdAt", direction: "DESC" }
        })
        console.log("data: ",response.data);
        return response.data
    } catch (error) {
        console.error(error);
    }
})
export const getproductById = createAsyncThunk<ProductRes, number>("/sellerProduct/getproductById", async (productId, { rejectWithValue }) => {
    try {

        const response = await api.get(`/api/sellers/products/${productId}`)
    
      
        return response.data
    } catch (error:any) {
        console.error(error);
        return rejectWithValue(error.data.response.message)
    }
})
export const createProduct = createAsyncThunk<ProductRes, CreateProductRequest>("/sellerProduct/createProduct", async (args, { rejectWithValue }) => {
    try {

        const response = await api.post(`/api/sellers/products/create`, args)
    
        return response.data
    } catch (error) {
        console.error(error);
    }
})
export const editProduct = createAsyncThunk<ProductRes, {req:ProductReq,productId:number|undefined}>("/sellerProduct/editProduct", async ({req,productId}, { rejectWithValue }) => {
    try {
        
        const response = await api.put(`/api/sellers/products/edit/${productId}`,req)
        
        return response.data
    } catch (error: any) {
        
        return rejectWithValue(error.response.data.message)
    }
})
interface SellerProductState {
    products: ProductRes[];
    loading: boolean;
    error: string | null | undefined;
    product:ProductRes|null;
}

const initialState: SellerProductState = {
    products: [],
    loading: false,
    error: null,
    product:null
}
//You're absolutely correct! The addCase in your Redux slice is necessary for each specific action (fetchSellerProduct and createProduct) because they update different parts of the state or handle different API calls.

// fetchSellerProduct:

// This action is responsible for fetching the seller's products.
// The state (specifically products, loading, and error) needs to be updated when the API request is pending, fulfilled, or rejected.
// createProduct:

// This action is used to add a new product to the list.
// The state only needs to be updated when the product creation is pending, successful, or fails.


export const sellerProductSlice = createSlice({
    // name have to match the "/sellerProduct in createThunk"
    name: "sellerProduct",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // one user make a request then the state will be pending once data is come the state fulfill request is filled
        builder
            .addCase(fetchSellerProduct.pending, (state) => {
                state.loading = true;
                state.error=null;
            })
            .addCase(fetchSellerProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.products = action.payload.content; // Update products array with fetched data
            })
            .addCase(fetchSellerProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message || "Failed to fetch products";
            })

            // create product
            .addCase(createProduct.pending, (state) => {
                state.loading = true;
                state.error=null;
            })
            .addCase(createProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.products.push(action.payload)
            })
            .addCase(createProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message
            })

            // get product by id
            .addCase(getproductById.pending, (state) => {
                state.loading = true;
                state.error=null;
            })
            .addCase(getproductById.fulfilled, (state, action:PayloadAction<ProductRes>) => {
                state.loading = false;
                state.product = action.payload;
            })
            .addCase(getproductById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message
            })

            // edit product
            .addCase(editProduct.pending, (state) => {
                state.loading = true;
                state.error=null;
            })
            .addCase(editProduct.fulfilled, (state, action:PayloadAction<ProductRes>) => {
                state.loading = false;
              const index=  state.products.findIndex((item)=>item.id==action.payload.id )
              if(index!==-1){
                state.products[index]= action.payload
              }
            })
            .addCase(editProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message
            })
    }
})

export const sellerProductSliceReducer = sellerProductSlice.reducer